var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { getMarkets, setClassNamesEventCard } from "../../../../helpers";
import { EventCardDetails } from "../EventCardDetails";
import { MarketsWrap } from "../MarketsWrap";
import { MarketsCountLink } from "../MarketsCountLink";
let EventCard = class EventCard extends React.Component {
    render() {
        const details = Object.assign(Object.assign({}, this.props), { markets: getMarkets(this.props.sport.config.markets, this.props.markets, this.props.event) });
        const classNames = setClassNamesEventCard(details.event.isLive, details.event.isSuspended, details.hideGameState, "ev-card");
        const cardTypeClass = details.event.cardType
            ? `rj-ev-list__ev-card--${details.event.cardType.toLowerCase()}`
            : "";
        return (React.createElement("div", { className: `rj-ev-list__ev-card ${cardTypeClass} ${classNames}`, "data-uat": "div-ev-list-ev-card" },
            React.createElement("div", { className: "rj-ev-list__ev-card__inner", "data-uat": "div-ev-list-ev-card-inner" },
                React.createElement(EventCardDetails, { details: details, componentPrefix: "ev-card" }),
                React.createElement(MarketsWrap, { details: details, componentPrefix: "ev-card" }),
                React.createElement(MarketsCountLink, { details: details, componentPrefix: "ev-card" }))));
    }
};
EventCard = __decorate([
    observer
], EventCard);
export { EventCard };
//# sourceMappingURL=EventCard.js.map